export type Column = '1' | '2' | '3'
export const isColumn = (value: string): value is Column => value === '1' || value === '2' || value === '3'
export const toColumn = (column: number): Column => {
	const c = column.toString()
	if(isColumn(c)) {
		return c
	}
	return '1';
}

export const restrictColumn: (lastColumn: Column) => (a: ArticleTemplate) => ArticleTemplate = lastColumn => {
	const maxColumn = parseInt(lastColumn)

	return a => parseInt(a.column) > maxColumn ? {...a, column: lastColumn} : a
}

export type Priority = number

export const sortByColumnAndPriority = (a: ArticleTemplate, b:ArticleTemplate) => {
	return a.column === b.column
		? a.priority - b.priority
		: parseInt(a.column) - parseInt(b.column)
}

export type ArticleTemplateFromPHP = {
	id: number
	title: string
	column: number
	priority: number
}

export type ArticleTemplate = {
	id: string
	title: string
	column: Column
	priority: Priority
}



// WEBPACK FOOTER //
// ./src/communications/article-templates/data.ts